export enum AuditorType {
  DS = 'DS',
  QC_AGENT = 'QC_AGENT',
  QC_TEAM_LEAD = 'QC_TEAM_LEAD'
}

export enum QuestionTag {
  IS_VIOLATION = 'IS_VIOLATION',
  VIOLATION_REASON_LIST = 'VIOLATION_REASON_LIST',
  CLEARANCE_REASON_LIST = 'CLEARANCE_REASON_LIST'
}

export enum QuestionType {
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTI_SELECT = 'MULTI_SELECT'
}

export enum OptionTag {
  VIOLATION_FOUND = 'VIOLATION_FOUND'
}

export enum TeamType {
  INHOUSE_TELE = 'INHOUSE_TELE',
  INHOUSE_CSA = 'INHOUSE_CSA',
  EXTERNAL_CSA_INHOUSE = 'EXTERNAL_CSA_INHOUSE',
  EXTERNAL_CSA_AGENCY = 'EXTERNAL_CSA_AGENCY'
}

export const TDME_AUDIT_TEAMS = [
  TeamType.INHOUSE_TELE,
  TeamType.INHOUSE_CSA,
  TeamType.EXTERNAL_CSA_INHOUSE,
  TeamType.EXTERNAL_CSA_AGENCY
] as const;
